import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import "../css/shopping.css";

const BrandsPage = () => {
  const navigate = useNavigate();
  const hasLoadedScripts = useRef(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);

  const Head = () => {
    return (
      <Helmet>
        <title>STAR TECH | BRANDS</title>
      </Helmet>
    );
  };

  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    const scripts = [
      // Add other script paths here...
      "/js/jquery.js",
      "/js/popper.min.js",
      "/js/bootstrap.min.js",
      "/js/jquery.fancybox.js",
      "/js/jquery-ui.js",
      "/js/jquery.countdown.js",
      "/js/mixitup.js",
      "/js/wow.js",
      "/js/appear.js",
      "/js/select2.min.js",
      "/js/swiper.min.js",
      "/js/owl.js",
      "/js/script.js",
      "/js/st-products-custom.js",
    ];

    const loadScripts = async () => {
      if (!hasLoadedScripts.current) {
        try {
          for (const script of scripts) {
            await loadScript(script);
          }
          hasLoadedScripts.current = true; // Mark as loaded
          console.log("All scripts loaded successfully");
        } catch (error) {
          console.error("Error loading scripts", error);
        }
      }
    };

    loadScripts();
    setTimeout(() => {
      setIsLoaded(true);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 1500);

    const fetchData = async () => {
      try {
        const response = await fetch("/products.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        // Calculate product count for each brand
        const brandsWithProductCount = data.brands.map((brand) => {
          const productCount = data.products.filter(
            (product) => product.brand_id === brand.id
          ).length;
          return {
            ...brand,
            products: { length: productCount },
          };
        });

        setBrands(brandsWithProductCount);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Head />
      <div className="page-wrapper">
        {/* <!-- Preloader --> */}
        {!isLoaded && <div className="preloader"></div>}
        <Header selection="products" />
        {/* <!-- Start main-content --> */}
        <section
          className="page-title"
          style={{
            backgroundImage: "url(../images/background/page-title.jpg)",
          }}
        >
          <div className="auto-container">
            <div className="title-outer">
              <h1 className="title">Brands</h1>
            </div>
          </div>
        </section>
        {/* <!-- end main-content --> */}
        {/* Brand Logos Section */}
        <div className="brand-logos-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="brand-logos-header">
                  <h3>Our Trusted Brands</h3>
                  <p>Discover products from leading technology manufacturers</p>
                </div>
                <div className="brand-logos-grid">
                  {brands.map((brand) => (
                    <div
                      key={brand.id}
                      className="brand-logo-item"
                      onClick={() =>
                        navigate(`/shopping/${encodeURIComponent(brand.name)}`)
                      }
                    >
                      <div className="brand-logo-container">
                        <img
                          src={`/images/brands/${brand.name}.png`}
                          alt={brand.name}
                          className="brand-logo-image"
                          onError={(e) => {
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "flex";
                          }}
                        />
                        <div
                          className="brand-logo-placeholder"
                          style={{ display: "none" }}
                        >
                          <i className="fas fa-building"></i>
                          <span>{brand.name}</span>
                        </div>
                      </div>
                      <div className="brand-info">
                        <h4>{brand.name}</h4>
                        <span>{brand.products?.length || 0} Products</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      {/* <!-- Scroll To Top --> */}
      <div className="scroll-to-top scroll-to-target" data-target="html">
        <span className="fa fa-angle-up"></span>
      </div>
    </>
  );
};

export default BrandsPage;
